// Shared currency utilities. Frontend-safe: no secrets, no Price IDs.
// The browser NEVER has authority over the charged currency — the backend
// re-detects country from trusted edge headers and picks the Stripe Price ID.

export type Currency = "usd" | "eur" | "gbp";

const GBP_COUNTRIES = new Set(["GB", "UK", "GG", "JE", "IM"]);
const EUR_COUNTRIES = new Set([
  "AT","BE","BG","HR","CY","EE","FI","FR","DE","GR","IE","IT",
  "LV","LT","LU","MT","NL","PT","SK","SI","ES",
]);

export function normalizeCountry(code: string | null | undefined): string | null {
  if (!code || typeof code !== "string") return null;
  const c = code.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(c)) return null;
  return c;
}

export function countryToCurrency(code: string | null | undefined): Currency {
  const c = normalizeCountry(code);
  if (!c) return "usd";
  if (GBP_COUNTRIES.has(c)) return "gbp";
  if (EUR_COUNTRIES.has(c)) return "eur";
  return "usd";
}

export function normalizeCurrency(cur: string | null | undefined): Currency {
  const c = (cur ?? "").toLowerCase();
  if (c === "eur" || c === "gbp" || c === "usd") return c;
  return "usd";
}

export function currencySymbol(cur: string | null | undefined): string {
  switch (normalizeCurrency(cur)) {
    case "eur": return "€";
    case "gbp": return "£";
    default: return "$";
  }
}

export function formatMoney(amount: number, cur: string | null | undefined): string {
  return `${currencySymbol(cur)}${amount.toFixed(2)}`;
}
